import { Router } from '@angular/router';
import { AppconfigService } from './../service/appconfig.service';
import { ReturnStatus } from './../class/return-status';
import { StudentevaluationService } from './../service/studentevaluation.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { JilabaAesED } from '../common/JilabaAesED';
import { JilabaKeyEnum } from '../common/JilabaKeyEnum';

@Component({
  selector: 'app-existinguserdialog',
  templateUrl: './existinguserdialog.component.html',
  styleUrls: ['./existinguserdialog.component.css']
})
export class ExistinguserdialogComponent implements OnInit {

  regno: string;
  mobileno: string;
  otp: string;
  keycode: string;
  blnotp: boolean;
  butblnotp: boolean;
  returnstatus: ReturnStatus;
  regnoarray: Array<string> = new Array<string>();
  btnfocuscolor = 'primary';
  btnfocuscolorbtnproceed = 'primary';

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<ExistinguserdialogComponent>,
    public snackBar: MatSnackBar, private studentservice: StudentevaluationService, private router: Router, private spinner: NgxSpinnerService) {
    this.blnotp = true;
    this.butblnotp = false;
    this.returnstatus = new ReturnStatus();
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close(null);
  }

  changecolor() {
    this.btnfocuscolor = 'accent';
  }

  changecolorback() {
    this.btnfocuscolor = 'primary';
  }

  changecolorbtnproceed() {
    this.btnfocuscolorbtnproceed = 'accent';
  }

  changecolorbackbtnproceed() {
    this.btnfocuscolorbtnproceed = 'primary';
  }


  mobilenovalidation() {
    if (this.mobileno !== undefined && this.mobileno !== null) {
      if (this.mobileno.toString().length !== 10) {
        document.getElementById('txtmobno').focus();
        this.snackBar.open('' + this.mobileno, 'Enter valid Mobileno', {
          duration: 2000,
        });
      } else {
        this.loadregno();
      }
    }
  }

  loadregno() {
    let map:any={
      "mobileno":this.mobileno,
      "tocken":JilabaAesED.Encrypt(this.mobileno,JilabaKeyEnum.CommonKey)
    }

    this.studentservice.loadregno(map).subscribe(data => {
      this.returnstatus = data;
      if (this.returnstatus.status === true) {
        this.regnoarray = this.returnstatus.returnObject;
        if (this.regnoarray.length > 0) {
          this.regno = this.regnoarray[0];
          document.getElementById('btnotp').focus();
        } else {
          this.close();
          alert('Mobile Number not registered...Please fill your Registration Details as New User');
        }
      } else {
        alert(this.returnstatus.description);
      }
    });
  }

  validation(): boolean {
    if (this.mobileno === undefined || this.mobileno === null) {
      document.getElementById('txtmobno').focus();
      alert('Enter Mobile Number...');
      return false;
    } else {
      return true;
    }
  }

  otpvalidation(): boolean {
    if (this.otp === undefined || this.otp === null) {
      document.getElementById('txtotp').focus();
      alert('Enter OTP Number...');
      return false;
    } else if (!this.keycode) {
      document.getElementById('txtotp').focus();
      alert('Time Expired...');
      return false;
    } else {
      return true;
    }
  }

  async sendOTP() {
    if (this.validation() === true) {
      this.blnotp = false;

      let map:any={
        "mobileno":this.mobileno,
        "tocken":JilabaAesED.Encrypt(this.mobileno,JilabaKeyEnum.CommonKey)
      }
      await this.studentservice.sendSuccessOTP(map).then((data) => {
        this.returnstatus = data;
        if (!this.returnstatus.status) {
          alert(this.returnstatus.description);
          return;
        }
        this.keycode = this.returnstatus.description;
      }, err => {
        console.log(err);
      });
      this.butblnotp = true;
      setTimeout(() => {
        document.getElementById('txtotp').focus();
      });
      setTimeout(() => {
        this.butblnotp = false;
        this.otp = '';
        this.keycode='';
      }, 120000);
    }
  }

  async VerifyOTP() {
    if (this.otpvalidation() === true) {
      let map: any = {
        "mobileno": this.mobileno,
        "key": this.keycode,
        "otp": this.otp,
        "tocken":JilabaAesED.Encrypt(this.mobileno,JilabaKeyEnum.CommonKey)+
        JilabaAesED.Encrypt(this.keycode,JilabaKeyEnum.CommonKey)+
        JilabaAesED.Encrypt(this.otp,JilabaKeyEnum.CommonKey)
      }
      await this.studentservice.verifySuccessOTP(map).then((data) => {
        this.returnstatus = data;
        if (!this.returnstatus.status) {
          alert(this.returnstatus.description);
          return;
        }

        this.proceed();
      }, err => {
        console.log(err);
      });
    }
  }


  async proceed() {
    this.spinner.show();

    AppconfigService.otpstatus = true;
    AppconfigService.regno = this.regno;
    AppconfigService.mobileno = this.mobileno;
    let map:any={
      "regno":this.regno,
      "tocken":JilabaAesED.Encrypt(this.regno,JilabaKeyEnum.CommonKey)
    }
    await this.studentservice.putLock(map).then(data => {
      this.returnstatus = data;
      if (this.returnstatus.status === false && this.returnstatus.description === 'Y') {
        alert('More than 1 User Not Allowed');
      } else {
        this.router.navigate(['/existingstudent']);
   
      }
    });
    this.close();
    this.spinner.hide();

  }

}
